;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import BlockHeader from './BlockHeader';

const query = /* GraphQL */ `
    query getBlock($id: String!, $preview: Boolean!) {
        blockHeader(preview: $preview, id: $id) {
            __typename
            anchorId
            headline
            subheadline
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockHeader },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockHeader;
}

const BlockHeaderServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockHeader {...block} />;
};

export default BlockHeaderServer;
